import { Attrs, MinzeElement } from 'minze'

export class LvcEventLocation extends MinzeElement {
  attrs: Attrs = [['text', '']]
  static observedAttributes = ['text']
  html = () => {
    return /*html*/ `
      <lvc-location-icon></lvc-location-icon>
      <div class="text">${this.text}</div>
      `
  }
  css = () => /*css*/ `
    :host {
      font-size: 12px;
      display: flex;
      justify-content: center;
      align-items: center;
      gap: 4px;
    }
    .text {
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 2;
      overflow: hidden;
    }

  `
}
